module.exports = __webpack_public_path__ + "img/plan-1-order-bt.a84934e3.png";